<template>
	<q-btn
		no-caps
		flat
		dense
		color="blue-grey-4"
		:label="$t(countryLabel)"
		size="1.1rem"
		v-if="user_countries.length > 1"
	>
		<q-menu fit>
			<q-list style="min-width: 100px">
				<q-item
					clickable
					v-close-popup
					v-for="(item, index) in user_countries"
					:key="index"
					@click="changeCountry(item)"
				>
					<q-item-section>
						{{ $t(item.name) }}
					</q-item-section>
				</q-item>
			</q-list>
		</q-menu>
		<q-tooltip>
		{{ $t('country') }}
		</q-tooltip>
	</q-btn>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'Country',
	i18nOptions: { namespaces: ['user'] },

	computed: {
		...mapGetters({
			id_user_client_country_selected: 'common/id_user_client_country_selected',
			id_user_client_selected: 'common/id_user_client_selected',
			id_user_language_selected: 'common/id_user_language_selected',
			user_clients: 'common/user_clients',
			user_countries: 'common/user_countries',
		}),

		countryLabel() {
			let obj = this.user_countries.find((obj) => {
				return obj.id == this.id_user_client_country_selected
			})
			if (obj) return obj.name
			else return ''
		},
	},

	methods: {
		changeCountry(item) {
			this.$store.dispatch('common/SET_COUNTRY', [item.id])
			this.show_countries = false
			this.setUserSelection()
		},

		getCountryList(type) {
			let obj = this.user_clients.find((obj) => obj.id == this.id_user_client_selected)
			if (obj) {
				this.$store.dispatch('common/SET_USER_COUNTRIES', [obj.countries])

				if (type === 'changed_client') {
					let obj_countries = obj.countries.find(
						(obj) => obj.id == this.id_user_client_country_selected
					)
					if (!obj_countries)
						this.$store.dispatch('common/SET_COUNTRY', [this.user_countries[0].id])
					this.setUserSelection()
				}
			}
		},

		setUserSelection() {
			this.$q.loading.show()

			let fd = new FormData()
			fd.append('client', this.id_user_client_selected)
			fd.append('country', this.id_user_client_country_selected)
			fd.append('language', this.id_user_language_selected)

			this.$axios
				.post('/accounts/set_user_selection/', fd)
				.then(() => {
					this.$mitt.emit('getAll', [])
				})
				.catch((e) => {
					console.log(e)
				})
		},
	},

	watch: {
		id_user_client_selected: function () {
			this.$store.dispatch('library/SET_FILTERS', [
				'',
				{ label: 'all_f', value: 'all' },
				{ label: 'all_f', value: 'all' },
				[],
				[],
			])
			if (this.user_clients) {
				this.getCountryList('changed_client')
			}
		},
	},

	created() {
		this.getCountryList('first_load')
	},
}
</script>
